import Modal from "./modal";
import H5 from "./h5";
import OnboardP from "./onboard-p";
import Input from "./input";
import Button from "./button";
import ButtonContent from "./button-content";
import DynamicIcon from "./dynamic-icon";
import Tooltips from "./tooltip";
import copy from "copy-to-clipboard";
import { useState, useEffect, useRef } from "react";

const DeleteTableModal = ({ handleDeleteTable, table, deleteModalOpen, toggleDeleteModal, folder= null, getTablesInFolder }) => {

    const [deleteInputValue, setDeleteInputValue] = useState("");
    const [isDeleteDisabled, setIsDeleteDisabled] = useState(true);
    const inputRef = useRef(null);

    useEffect(() => {
        if (deleteModalOpen) {
            inputRef?.current?.focus();
        }
    }, [deleteModalOpen]);

    useEffect(() => {
        if ((!folder && deleteInputValue === table.name) || (folder && deleteInputValue === (table.name || folder.folder_name))) {
            setIsDeleteDisabled(false);
        } else {
            setIsDeleteDisabled(true);
        }
    }, [deleteInputValue]);

    const handleDeleteInputChange = (e) => {
        setDeleteInputValue(e.target.value);
    };

    const handleConfirmDelete = () => {
        if (deleteInputValue === table.name || (folder && deleteInputValue === folder.folder_name)) {
            if (folder) {
                const tablesInFolder = getTablesInFolder ? getTablesInFolder(table.uuid) : [];
                if (tablesInFolder && tablesInFolder.length > 0) {
                    tablesInFolder.forEach(t => {
                        handleDeleteTable(t.uuid);
                    });
                }
                handleDeleteTable(table.uuid);
            } else {
                handleDeleteTable(table.uuid);
            }
            toggleDeleteModal();
            setDeleteInputValue("");
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !isDeleteDisabled) {
            handleConfirmDelete();
        }
    };

    const [showCheckIcon, setShowCheckIcon] = useState(false);

    const handleCopyName = () => {
        copy(table?.name || folder?.folder_name);
        setShowCheckIcon(true);
        setTimeout(() => {
            setShowCheckIcon(false);
        }, 3000);
    };

    return (
        <Modal heading={`Permently delete ${folder ? folder.folder_name : table.name}?`} additionalclasses="lg:w-[420px] w-[90%] m-auto" isOpen={deleteModalOpen} toggleModal={toggleDeleteModal}>
            <div className="grid gap-[16px] content-start">
                <div className="flex items-start gap-[8px]">
                    <DynamicIcon name="triangle-alert" color="custom-text-warning-500 !cursor-pointer" size={18} />
                    <OnboardP additionalClass='text-[12px]'>Warning: Deleting this {folder ? 'folder' : 'table'} cannot be undone. {folder && 'All tables inside it will also be permanently deleted.'}</OnboardP>
                </div>
                <div className="flex justify-between items-center py-[10.5px] px-[8px] text-[12px] leading-[16px] custom-text-grey-500 custom-bg-grey-50 rounded-[4px]">
                    {table?.name || folder?.folder_name}
                    {showCheckIcon ? (
                        <DynamicIcon name="check" color="custom-text-success-500" size={18} />
                    ) : (
                        <DynamicIcon
                            name="copy"
                            color="!cursor-pointer"
                            size={18}
                            onClick={handleCopyName}
                        />
                    )}
                </div>
                <Input
                    additionalclasses="max-w-full"
                    value={deleteInputValue}
                    onChange={handleDeleteInputChange}
                    onKeyDown={handleKeyDown}
                    hasValue={true}
                    placeholder={`The name of your ${folder ? 'folder' : 'table'}`}
                    label='To confirm deletion please type  '
                    ref={inputRef}
                />
                <div className="grid relative justify-end">
                    <Tooltips
                        position={isDeleteDisabled ? "bottom" : ""}
                        content={isDeleteDisabled ? "Fill the correct table name" : ""}
                    >
                        <Button
                            additionalclasses="w-[82px] !mt-[8px] !h-[38px]"
                            handleClick={handleConfirmDelete}
                            disabled={isDeleteDisabled}
                        >
                            <ButtonContent>Delete</ButtonContent>
                        </Button>
                    </Tooltips>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteTableModal;